import React from 'react';
import css from '@/css/module/billing.css';
import flex from '@/css/module/flex.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@trevor/ui-components';
import { datasourceUrlPrefix } from '@/util/helpers/ajax-helpers';

const handleOpenInvoices = () =>
  window.open(`${datasourceUrlPrefix()}/invoices`, '_blank');

export const InvoiceHistory: React.FC = () => {
  return (
    <div className={css.section}>
      <div className={`${flex.row} ${flex.alignItemsStart}`}>
        <div className={css.billingIcon}>
          <FontAwesomeIcon icon="history" />
        </div>
        <div className={flex.alignItemsCenter}>
          <b>History:</b>
          &nbsp;&nbsp;
          <Button variant="secondary" size="small" onClick={handleOpenInvoices}>
            View invoices
          </Button>
        </div>
      </div>
    </div>
  );
};
